import { useTranslation } from '@rhino-project/core/i18n';
import { useMemo } from 'react';
import { useGlobalComponent } from '@rhino-project/core/hooks';
import {
  useTableInheritedProps,
  TableInheritedProps
} from '@rhino-project/core/hooks';

const CellFloatBase = ({
  empty = '-',
  ...props
}: TableInheritedProps & { empty?: string }) => {
  const { locale } = useTranslation();
  const { getValue, inheritedProps } = useTableInheritedProps(props);
  const value = useMemo(() => {
    const raw = getValue!();
    return raw == null || raw === ''
      ? empty
      : new Intl.NumberFormat(locale.replaceAll('_', '-'), {
          maximumFractionDigits: 20
        }).format(Number(raw));
  }, [empty, getValue, locale]);

  return <div {...inheritedProps}>{value}</div>;
};

export const CellFloat = (props: TableInheritedProps) =>
  useGlobalComponent('CellFloat', CellFloatBase, props);
